import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function AboutUs() { 
  useEffect(() => {
    document.title = 'About Us-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>About Us</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">About Us</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                  <p>Started on July 1, 2022, Carmel Convent School, Dharuhera has a spacious campus with well planned buildings and playgrounds. The school is recognized by the Directorate of Education of Haryana. It is affiliated to the Central board of secondary education. </p> 
                  <p>The Foundation stone of Carmel convent School, Dharuhera was laid by Rev. Msgr. Wolfgang Johann Huber President of ‘Missio’, Munich, Germany on September 14, 2019 in the presence of Sister Maria Nirmalini A.C. (Superior General) of the Apostolic Carmel Congregation.  It was inaugurated by Sister Nirmalini and blessed by Bishop Deepak Tauro Auxiliary Bishop of the Archdiocese of Delhi.   </p> 
                  <p>The Apostolic Carmel is a leader in education for both girls and boys, where both learners and educators thrive.  It is a fitting place to access to a wide range of challenging and extending learning opportunities. </p> 
                  <p>We recognize the need to acknowledge individual differences and promote development and provide appropriate opportunities to address the needs of our students. </p> 
                  <p>We also empower our students to serve and inspire the community and become strong global citizens and socially responsible leaders. Thus, our students inspire us with their energy, confidence and love every single day. </p>
               <h5>Objectives</h5>
                <p>Our aim is to develop, educate and raise awareness among our students:</p>
                <ul className="mainlist">
                <li> Capable of responding to life’s challenges with joy and a deep faith in God. </li> 
                <li> Whose choices and decisions are guided by right values. </li> 
                <li> Enriched by our cultural heritage. </li> 
                <li> Committed to the service of our people. </li>
                </ul>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AboutUs;
